import { render, staticRenderFns } from "./ModuleDetailMenu.vue?vue&type=template&id=5943d171&"
import script from "./ModuleDetailMenu.vue?vue&type=script&lang=ts&"
export * from "./ModuleDetailMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports